<template>
  <div :class="wrapperClass" :style="wrapperStyle" v-bind="wrapperAttrs">
    <button
      v-for="item in items"
      :key="item.value"
      :type="type"
      :class="getItemClass(item.value)"
      @click="handleSelect(item.value)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{
    items: Array<{ value: string; label: string }>;
    modelValue: string;
    itemClass?: string;
    activeClass?: string;
    columns?: number;
    type?: "button" | "submit" | "reset";
  }>(),
  {
    itemClass: "",
    activeClass: "app-tab--active",
    columns: undefined,
    type: "button",
  },
);

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void;
}>();

const attrs = useAttrs();

const wrapperClass = computed(() => ["app-tabs", attrs.class as any]);
const wrapperStyle = computed(() => ({
  "--app-tabs-columns": String(props.columns || props.items.length || 1),
}));

function getItemClass(value: string) {
  return [
    "app-tab",
    props.itemClass,
    props.modelValue === value ? props.activeClass : null,
  ];
}

const wrapperAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});

function handleSelect(value: string) {
  emit("update:modelValue", value);
}
</script>

<style scoped>
.app-tabs {
  display: grid;
  grid-template-columns: repeat(var(--app-tabs-columns, 2), minmax(0, 1fr));
  gap: 8px;
  background: #ffffff;
  padding: 4px;
  border-radius: 14px;
  border: 1px solid #e9e9e9;
}

.app-tab {
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--color-subtitle-light);
  padding: 8px 10px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  background: #f7f7f7;

}

.app-tab--active {
  background: #f3e2e2;
  color: var(--color-theme);
  border: 0;
  padding: 0 10px;
}
</style>
